exchangeService.$inject = ['$http', 'apiBase', '$q']

function exchangeService ($http, apiBase, $q) {
  var endpointPath = apiBase + 'v2/rates/exchangerates'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  return {
    listAllRates: function (params) {
      var deferred = $q.defer()

      $http({
        url: endpoint(),
        method: 'GET',
        timeout: deferred.promise,
        params: params,
        name: 'listAllRates'
      }).then(function (result) {
        deferred.resolve(result)
      }, function () {
        deferred.reject([])
      })

      return deferred.promise
    },

    convert: function (data) {
      var deferred = $q.defer()

      $http({
        url: endpoint(),
        method: 'POST',
        timeout: deferred.promise,
        data: data
      }).then(function (result) {
        deferred.resolve(result)
      }, function (error) {
        deferred.reject(error)
      })

      return deferred.promise
    },

    listAllCurrency: function (lang) {
      return $http({
        url: endpoint('currencies'),
        method: 'GET',
        params: { lang: lang }
      })
    },

    listAllCrossRates: function (params) {
      return $http({
        url: endpoint('cross'),
        method: 'GET',
        params: params
      })
    },

    listAllTimeRates: function (params) {
      return $http({
        url: endpoint('times'),
        method: 'GET',
        params: params
      })
    }
  }
}

exports.exchangeService = exchangeService
